import React from "react";
import { ReactComponent as AIIcon } from "../../../../images/ai.svg";
import { cn } from "../../../../services/common/className";
import UserState from "../../../../slices/user/UserState";
import { useSelector } from "react-redux";
import { userSelector } from "../../../../slices/user/userSlice";
import { ChatMessageModel, ChatPromptModel } from "../../../../app/data/chat/models";
import Tag from "../../../../ui-components/molecules/tag/tag";
import { TagColor } from "../../../../app/data/common/tagColor";
import Table from "../../../../ui-components/table/table";
import Button, { ButtonThemes } from "../../../../ui-components/button/button";

export interface ChatMessageProps {
  message: ChatMessageModel,
  mix?: string,
  onPromptClick?: (prompt: ChatPromptModel) => void;
  isLoading?: boolean;
  onRetry?: () => void;
}

const ChatMessage: React.FC<ChatMessageProps> = ({ message, mix, onPromptClick, isLoading, onRetry }) => {
  const userState: UserState = useSelector(userSelector);

  return (
    <div className={cn("xgs-chat__message")({ incoming: message.incoming, outcoming: !message.incoming }, mix)}>
      <div className="xgs-chat__message__user-wrapper">
        <div className="xgs-chat__message__user">
          {message.incoming ? <AIIcon /> : userState.profile?.firstName.slice(0, 1)}
        </div>
      </div>

      <div className="xgs-chat__message__content">
        <div className="xgs-chat__message__text">
          {isLoading ? (
            <div className="xgs-chat__message__loader"/>
          ) : <div dangerouslySetInnerHTML={{ __html: message.text?.replaceAll("\n", "<br/>") || "" }}/>}
          {message.error && (
            <div className="xgs-chat__message__error">
              <span>Something went wrong. Please try again.</span>
              {onRetry && <Button theme={ButtonThemes.blue} onClick={onRetry}>Try again</Button>}
            </div>
          )}
        </div>
        {message.table && (
          <div className="xgs-chat__message__table">
            <Table
              data={message.table.data}
              columns={message.table.columns}
              autoHeight={false}
              responsive={false}
              minTableHeight={380}
              maxTableWidth={600}
              infiniteScroll
              infiniteScrollLoading={false}
              infiniteScrollHasNext={false}
              strictMinTableHeight
              // rowHeight={100}
            />
          </div>
        )}

        {!!message.prompts?.length && (
          <div className="xgs-chat__message__prompts">
            {message.prompts.map(prompt => (
              <Tag key={prompt.promptId} mods={{ color: TagColor.BLUE }} onClick={() => { onPromptClick?.(prompt) }}>{prompt.promptMessage}</Tag>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ChatMessage;
